var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label-info"},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"label-info__icon"},[_c('img',{attrs:{"src":require('@/assets/svg/label-help.svg'),"alt":"Ikona info"}}),_c('span',[_vm._v(_vm._s(_vm.info))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }